import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { Permission } from "../../components/common/static-data-common";
import { RoleModel } from "../../_Models/user/role.model";
import { UpdateSessionModel, UserModel } from "../../_Models/user/user.model";
import { UserLoginModel } from "../../_Models/useraccount/userLogin.model";
import { UtilityService } from "../common/utility.service";
import { UserProfileService } from "../UserAccount/userprofile.service";

@Injectable({ providedIn: "root" })
export abstract class IOAuthService {
  protected user: UserModel;
  protected identityBaseurl: string;
  protected subDomainName: string;
  protected baseUrl: string;

  constructor(
    identityBaseUrl: string,
    protected utility: UtilityService,
    protected userService: UserProfileService,
    protected router: Router,
    protected http: HttpClient
  ) {
    this.identityBaseurl =
      this.utility.removeSlashFromUrlAtEnd(identityBaseUrl);

    let origin = new URL(window.location.href).origin;
    this.baseUrl = document.getElementsByTagName("base")[0]?.href || origin;
    this.baseUrl = this.utility.removeSlashFromUrlAtEnd(this.baseUrl);

    this.subDomainName = this.utility.getSubdomainFromUrl();
  }

  abstract configureService(): void;
  abstract authorizeAndLogin(): Promise<void>;
  abstract logOut(): Promise<void>;
  abstract getAccessToken(): string;
  abstract validatedSubDomain();
  abstract checkAndLoadDiscoveryDocument();
  abstract isAuthenticated(): boolean;

  public async mapProfileData(response) {
    const hasPIP = response.packageFeatures?.some(
      (f: any) => f.name === "PIP" && f.isActive
    );

    const hasVendor =
      response.packageFeatures?.some(
        (f: any) => f.name?.toLowerCase() === "vendor" && f.isActive
      ) &&
      !response.roles?.some(
        (r: any) => r.roleName?.toLowerCase() === "label supplier"
      );
    this.user = {
      id: response.id,
      fullName: response.fullName,
      userName: response.userName,
      orgImagePath: response.orgImagePath,
      profileImage: response.profileImageUrl,
      entityName: response.entityName,
      countryId: response.countryId,
      usertype: response.userType,
      customerid: response.customerId,
      supplierid: response.supplierId,
      inspectionCompanyid: response.inspectionCompanyId,
      factoryid: response.factoryId,
      staffId: response.staffId,
      profiles: response.userProfileList,
      showHeader: true,
      changePassword: true,
      userProfileList: response.userProfileList,
      roles: response.roles.map((x) => {
        let role: RoleModel = {
          id: x.id,
          roleName: x.roleName,
          qcRole: x.qcRole,
          roleType: x.roleType,
        };
        return role;
      }),
      rights: response.rights,
      rightsDB: response.rights,
      permissions: response.permissions,
      packageFeatures: response.packageFeatures,
      packageId: response.packageId,
      defaultFeatureId: null, //response.defaultFeatureId,
      // routes: hasPIP
      //   ? ["/plmlandingdashboard/PLMLandingDashboard"]
      //   : [response.defaultFeatureRightPath],

      routes:
        hasPIP && hasVendor
          ? ["/plmlandingdashboard/PLMLandingDashboard"]
          : hasPIP
            ? ["/plmlandingdashboard/PLMLandingDashboard"]
            : hasVendor
              ? [response.defaultFeatureRightPath]
              : [response.defaultFeatureRightPath],
      subDomainName: response.subDomainName,
      appLanguage: response.appLanguage,
      customerContactId: response.customerContactId,
      supplierContactId: response.supplierContactId,
      isFirstTimeLogin: response.isFirstTimeLogin || false,
      isHeaderIconIsShow: response.isHeaderIconIsShow || false,
      isFooterIconIsShow: response.isFooterIconIsShow || false,
      isSupportIconIsShow: response.isSupportIconIsShow || false,
      customerName: response.customerName || "",
      supplierType: response.supplierType || "",
      pageIds: response.pageIds || []
    };

    let data = new UserLoginModel();
    data.user = this.user;
    localStorage.setItem("currentUser", JSON.stringify(data.user));

    localStorage.setItem("lang", data.user.appLanguage || "en");
    this.utility.setLangSubject(localStorage.getItem("lang"));

    if (this.user.packageId != null)
      localStorage.setItem(
        "service",
        JSON.stringify(this.user.defaultFeatureId)
      );

    this.validatedSubDomain();
    await this.processSuccessLoginData(hasVendor);
  }

  protected async getUser() {
    try {
      await this.postReceivedToken();
      const userData = await this.userService.getUser();
      if (userData) {
        await this.mapProfileData(userData);
        //this.copySessionRelatedItems_SessionToLocaltorage();
      } else {
        await this.logOut();
      }
    } catch (error) {
      console.error("Error fetching user data", error);
      await this.router.navigate(["/error/usernotfound"]);
    }
  }

  public async postReceivedToken() {
    // console.log("postReceivedToken called.");
    const sessionId = localStorage.session_state;
    const userId = JSON.parse(
      localStorage.getItem("id_token_claims_obj") || "{}"
    );
    await this.addSessionCurrentUser(sessionId, userId);
  }

  protected async addSessionCurrentUser(sessionId, userId) {
    // console.log("addSessionCurrentUser called.");
    const model: UpdateSessionModel = {
      SessionId: sessionId,
      UserId: userId.sub || 0,
    };
    return this.http
      .post<any>(
        `${this.identityBaseurl.toString()}/Account/AddSessionCurrentUser`,
        model
      )
      .toPromise();
  }

  public async processSuccessLoginData(hasVendor) {
    // console.log("processSuccessLoginData called.");
    console.log(hasVendor)
    if (
      !this.user.changePassword ||
      (this.user.permissions &&
        this.user.permissions.length === 1 &&
        this.user.permissions.includes(Permission.Change_Password_List))
    ) {
      await this.router.navigate(["/changepassword"]);
    } else if (this.user.routes?.length && this.user.routes[0] != "") {
      await this.router.navigate([`/${this.user.routes[0]}`]);
    } else {
      await this.router.navigate(["/forbidden"]);
    }
  }

  /// To allow same session to multiple table, need to copy session to localstroage when user login
  // public copySessionRelatedItems_SessionToLocaltorage() {
  //   this.copyStorageItem(sessionStorage, localStorage, 'expires_at');
  //   this.copyStorageItem(sessionStorage, localStorage, 'id_token_expires_at');
  //   this.copyStorageItem(sessionStorage, localStorage, 'access_token_stored_at');
  //   this.copyStorageItem(sessionStorage, localStorage, 'id_token_stored_at');
  //   this.copyStorageItem(sessionStorage, localStorage, 'id_token');
  //   this.copyStorageItem(sessionStorage, localStorage, 'access_token');
  //   this.copyStorageItem(sessionStorage, localStorage, 'id_token_claims_obj');
  //   this.copyStorageItem(sessionStorage, localStorage, 'session_state');
  //   this.copyStorageItem(sessionStorage, localStorage, 'granted_scopes');
  // }

  /// To allow same session to multiple table, need to copy localstroage to session when first request came
  // public copySessionRelatedItems_LocalToSessionStorage() {
  //   this.copyStorageItem(localStorage, sessionStorage, 'expires_at');
  //   this.copyStorageItem(localStorage, sessionStorage, 'id_token_expires_at');
  //   this.copyStorageItem(localStorage, sessionStorage, 'access_token_stored_at');
  //   this.copyStorageItem(localStorage, sessionStorage, 'id_token_stored_at');
  //   this.copyStorageItem(localStorage, sessionStorage, 'id_token');
  //   this.copyStorageItem(localStorage, sessionStorage, 'access_token');
  //   this.copyStorageItem(localStorage, sessionStorage, 'id_token_claims_obj');
  //   this.copyStorageItem(localStorage, sessionStorage, 'session_state');
  //   this.copyStorageItem(localStorage, sessionStorage, 'granted_scopes');
  // }

  /// remove all login related information when user logout
  protected removeSessionRelatedItems() {
    let storages = [localStorage, sessionStorage];
    this.removeItemFormStorage(storages, "expires_at");
    this.removeItemFormStorage(storages, "id_token_expires_at");
    this.removeItemFormStorage(storages, "access_token_stored_at");
    this.removeItemFormStorage(storages, "id_token_stored_at");
    this.removeItemFormStorage(storages, "id_token");
    this.removeItemFormStorage(storages, "access_token");
    this.removeItemFormStorage(storages, "id_token_claims_obj");
    this.removeItemFormStorage(storages, "session_state");
    this.removeItemFormStorage(storages, "isTokenRefreshing");
  }

  private copyStorageItem(
    FromStorage: Storage,
    ToStorage: Storage,
    key: string
  ) {
    let value = FromStorage.getItem(key);

    if (value) ToStorage.setItem(key, value);
  }

  private removeItemFormStorage(storages: Storage[], key: string) {
    if (storages) {
      storages.forEach((storage) => {
        storage.removeItem(key);
      });
    }
  }
}
